module.exports = __webpack_public_path__ + "assets/img/travel-day23.0a0591ac.png";